import axios from 'axios'
import ReactDOM from 'react-dom';
import { getUserData } from './common.services';
import SessionExpired from '../components/popUp/SessionExpired';

export const fetch = (url, data, method, isAuthTokenRequired, headers) => {
    const getAuthToken = () => {
        let access_token = getUserData()?.access_token
        if (access_token)
            return { Authorization: `Bearer ${access_token}` };
        else {
            localStorage.clear()
            window.location.reload()
        }
    }
    return axios({
        url,
        method,
        data: data ? data : null,
        headers: isAuthTokenRequired ? getAuthToken() : { ...headers }
    })
        .then((res) => {
            return res
        })
        .catch((e) => {
            if (e.response?.status === 401) {
                ReactDOM.render(<SessionExpired status={true} description="Your session has been expired. Log in to continue." />, document.getElementById("app-alerts"))
            }
            else if (e.response?.status === 403) {
                ReactDOM.render(<SessionExpired status={true} description="Your access has been revoked." />, document.getElementById("app-alerts"))
            }
            return e
        })
}